export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-8401WQHD_white-99e4c61f7385e5e40f76009691fc9fe8.webp";